import { z } from 'zod'

// the broker accounts the global Income page aggregates, persisted per user under
// UserSettingKey.GLOBAL_INCOME_ACCOUNTS. `accountId` is the T-Bank account id (the value the
// investments routes carry), not the TbankBrokerAccount row id.
export const globalIncomeAccountRefSchema = z.object({
  connectionId: z.string().guid(),
  accountId: z.string().min(1),
})

export type GlobalIncomeAccountRef = z.infer<typeof globalIncomeAccountRefSchema>

// bounded so the stored setting stays well inside the serialized-value cap on user settings
export const globalIncomeAccountsSchema = z.array(globalIncomeAccountRefSchema).max(50)

export type GlobalIncomeAccounts = z.infer<typeof globalIncomeAccountsSchema>
